import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { PageFooter } from '../components/PageFooter';
export function LandingPage() {
  return <main className="min-h-screen bg-cream font-body text-charcoal" data-id="element-226">
      <HeroSection data-id="element-227" />
      <OpeningHook data-id="element-228" />
      <ProblemSection data-id="element-229" />
      <FailedSolutions data-id="element-230" />
      <MechanismSection data-id="element-231" />
      <WhatYouGet data-id="element-232" />
      <AudienceSection data-id="element-233" />
      <HowItWorks data-id="element-234" />
      <ProofSection data-id="element-235" />
      <FAQSection data-id="element-236" />
      <OfferSection data-id="element-237" />
      <PageFooter data-id="element-238" />
    </main>;
}